import { breakpoints, theme, ThemeOverrides } from "@shapeable/theme";
import { Banner, Color } from "@shapeable/types";
import { WARM_GREY } from "@shapeable/ui";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';

export const VILLARS_PRIMARY_BLUE = '#00BFF6';
export const VILLARS_TURQUOISE = '#00C4D6';
export const VILLARS_PURPLE = '#6739BE';
export const VILLARS_FUCHSIA = '#ab286f';

export const LIGHT_BIEGE = '#F7F5F3';
export const LIGHT_BROWN = '#AD9A8A';

export const VERY_LIGHT_BROWN = '#D5CDC4';

export const CONFERANCE_COLORS = [VILLARS_PRIMARY_BLUE, VILLARS_PURPLE,, VILLARS_FUCHSIA, VILLARS_TURQUOISE];

export const COLOR_LIGHT_BROWN: Color = {
  id: 'light-brown',
  slug: 'light-brown',
  value: LIGHT_BROWN,
};

export const COLOR_GREEN: Color = {
  id: 'green',
  slug: 'green',
  value: VILLARS_PRIMARY_BLUE,
};

export const BANNER_EVENT: Banner = {
  id: 'banner-event',
  name: 'Banner Event',
  slug: 'banner-event',
  image: {
    id: 'recYRsg6ML0rqtefA_image',
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1668989821/villars-institute/banner/sub-page-banner-event_image__event-banner.jpg',
    width: 1920,
    height: 576,
  },
};

export const themeOverrides: ThemeOverrides = {
  font: {
    family: {
      serif: "'Cormorant Garamond', georgia, serif",
      sans: 'Jost, sans-serif',
      heading: 'Jost, sans-serif',
      copy: 'Jost, sans-serif',
    }
  },
  light: {
    color: {

      midBrand: YELLOW_DARK,
      primary: VILLARS_PRIMARY_BLUE,
      secondary: LIGHT_BROWN,
      buttonHover: VILLARS_PRIMARY_BLUE,

    },
  },
  dark: {
    color: {
      primary: VILLARS_PRIMARY_BLUE,
      buttonHover: VILLARS_PRIMARY_BLUE,
    }
  }
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--site-menu-bar__title {
      color: ${theme.COLOR('canvas')}
    }

    .shp--slice-key-message {
      text-align: left;

      .shp--content {
        line-height: 1.10em;
        font-family: ${theme.FONT('sans')};
        font-weight: 400;
      }
      
      .shp--slice-key-message__links {
        align-items: flex-start;
      }
    }

    .shp--slice-layout-content-with-image {
      .shp--content-node {
        color: ${theme.COLOR('inherit')};
      }
      li::before {
        color: ${theme.COLOR('inherit')};
      }
    }

    #customers .shp--button {
      color: ${theme.COLOR('light')};
      ${theme.FILL('light')};
      border: 2px dotted ${theme.COLOR('light')};
      &:hover {
        color: ${theme.COLOR('#FCB10F')};
        ${theme.FILL('#FCB10F')};
        border: 2px dotted ${theme.COLOR('#FCB10F')};
      }
    }

  `,
  tablet: css`
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }

  `,
  desktop: css`
    .shp--slice-section-color-block {
      min-height: 600px;
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      gap: 1em;
    }

    
    
  `,
});